import React, {useEffect, useState} from 'react';
import styles from './SmallSpinner.module.scss';
import moment from 'moment';
import SafeImage from '../SafeImage';

const SmallSpinner = props => {
    const { className = '', visible: expectedVisible, delayShow = 250, stayVisible = 250, inline, size } = props,
        [visible, setVisible] = useState(expectedVisible),
        [lastChange, setLastChange] = useState(moment()),
        style = {}

    if (size) {
        style.width = size;
        style.height = size;
    }

    useEffect(() => {
        setLastChange(moment());
    }, [visible]);

    useEffect(() => {
        if (expectedVisible) {
            let timeout = setTimeout(() => {
                setVisible(true);
            }, delayShow);
            return () => clearTimeout(timeout);
        } else {
            const diff = moment().diff(lastChange);

            if (diff < stayVisible) {
                let timeout = setTimeout(() => {
                    setVisible(false);
                }, stayVisible - diff);
                return () => clearTimeout(timeout);
            } else {
                setVisible(false);
            }
        }
    }, [expectedVisible]);

    return (
        <div className={[styles.SmallSpinner, className, visible ? styles.visible : styles.hidden].join(' ')} style={style}>
            <SafeImage className="" aria-hidden="true" src="/img/Icon.png" />
        </div>
    );
};

export default SmallSpinner;
